export function ordinalToScaledDisplayRating(rawOrdinal) {
  const TARGET_BASELINE = 200; // Starting display rating for a brand-new player (mu 25, sigma 25/3 -> ordinal 0)
  const TARGET_PEAK = 2800;    // Benchmark peak rating for elite players
  const MAX_ORDINAL = 45;      // Realistic max ordinal in OpenSkill: elite mu ~48 with sigma ~1.0
  const DISPLAY_FLOOR = 50;    // Minimum display rating so loss streaks / high uncertainty stay above 0

  // Scale factor maps raw ordinal range [0, 45] onto display rating range [200, 2800]
  const scaledValue = TARGET_BASELINE + (rawOrdinal * ((TARGET_PEAK - TARGET_BASELINE) / MAX_ORDINAL));

  return Math.max(DISPLAY_FLOOR, Math.round(scaledValue));
}